module.exports = __webpack_public_path__ + "components/flag/static/square/mp-e25660cd3e70288f7ac806b7e9f91d0c.svg";